import  { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
// import i1 from "../Images/4/1.jpg";
// import i2 from "../Images/4/2.jpg";
// import i3 from "../Images/4/3.jpg";
// import i4 from "../Images/4/4.jpg";
import W1 from "../Images/W1.png";
import Count from '../Component/Count';

// const imageVariants = {
//   hidden: { opacity: 0, scale: 0.8, y: 50 },
//   visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
// };

const textVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

const FourImg = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { triggerOnce: false, threshold: 0.2 });

  return (
    <>
      <div className='w-full md:h-auto lg:h-[600px]' ref={ref}>
        
        {/* Image Section
        <motion.div 
          className='w-full md:w-1/2 p-4 md:p-8 flex gap-7 md:flex-col items-center'
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={imageVariants}
        >
          {/* <div className='flex flex-col md:flex-row gap-2 md:gap-5'>
            <motion.img src={i1} alt="" className='w-full relative md:w-[48%] lg:w-[242px] h-[120px] md:h-[200px] lg:top-25 lg:h-[142px] rounded-[20px]'/>
            <motion.img src={i2} alt="" className='w-full relative md:w-[48%] lg:w-[300px] h-[180px] md:h-[280px] lg:h-[242px] rounded-[20px]'/>
          </div>
          <div className='flex flex-col md:flex-row gap-2 md:gap-5 mt-2 md:mt-5'>
            <motion.img src={i3} alt="" className='w-full relative md:w-[48%] lg:w-[300px] h-[180px] md:h-[280px] lg:h-[242px] rounded-[20px]'/>
            <motion.img src={i4} alt="" className='w-full relative md:w-[48%] lg:w-[242px] h-[120px] md:h-[200px] lg:h-[142px] rounded-[20px]'/>

          </div> 
        </motion.div>*/}

        {/* Content Section */}
        <motion.div 
          className='w-full  flex items-center justify-center p-4 md:p-8'
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={textVariants}
        >
          <div className="w-full max-w-4xl text-center p-6 md:p-8 text-center md:text-left">
            
            {/* About Button */}
            <div className="relative flex md:justify-center justify-center items-center">
              <button className="bg-[#432DD7] font-[Nunito] text-white w-[120px] md:w-[158px] h-[45px] md:h-[60px] rounded-full text-md md:text-lg font-medium">
                About
              </button>
              <img 
                src={W1} 
                alt="Illustration" 
                className="absolute w-12 md:w-20 h-12 md:h-20 -top-8 md:-top-15 left-24 md:left-90"
              />
            </div>

            {/* Heading */}
            <h1 className="text-[22px] md:text-[30px] lg:text-[40px] font-bold text-gray-900 mt-4" style={{ fontFamily: 'PT Sans' }}>
              Turning Your Vision
            </h1>

            {/* Subheading */}
            <p className="text-[22px] md:text-[30px] lg:text-[40px] text-purple-600 mt-2 font-[Allison]">
              into Digital Reality
            </p>

            {/* Description */}
            <p className="text-gray-700 mt-4 font-[Nunito] text-sm md:text-base">
              At Godhani Technology, we bring your ideas to life with cutting-edge IT solutions that drive innovation and growth. Whether it's a website, mobile app, AI software, or an e-commerce platform, we create digital solutions that transform businesses.
            </p>

            <p className="text-gray-700 mt-4 font-[Nunito] text-sm md:text-base">
              Our expert team specializes in Web & App Design, AI & ML Development, UI/UX Design, and Custom Software Solutions. We ensure that your business gets the technological edge it deserves.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Project Section */}
      <div className='bg-[#432DD7]'>
        <Count />
      </div>
    </>
  );
};

export default FourImg;
